import React from "react";
import { Form } from "react-bootstrap";
export function SwitchToggler({ name, className, label = "", ...props }) {
  return (
    <>
      <Form.Check type="switch" id={name} name={name} label={label} className={className} {...props} />
    </>
  );
}
